module.exports = __webpack_public_path__ + "img/demo7.0b259dac.png";